module.exports = __webpack_public_path__ + "img/Folded_Paper_Gowallet_gif3.d7f698ae.gif";